<template>
  <div
    data-ctl-click="true"
    class="pctl__img-wrapper"
    @click.prevent="toggleQuickView"
    @keydown="handleKeyDownOnQuickView"
    tabindex="0"
  >
    <ImageField
      :key="product.featured_image"
      class="pctl__product-img"
      :obj="{ url: product.featured_image, alt: product.title, width: 456, height: 564 }"
    />
    <div class="pctl__quickview-btn" tabindex="0">Quickview</div>
  </div>
  <span class="pctl__product-title" role="heading" aria-level="2">{{ product.title }}</span>
  <div class="pctl__reviews">
    <div
      class="yotpo-widget-instance"
      data-yotpo-instance-id="498880"
      :data-yotpo-product-id="product.product.id"
    ></div>
  </div>
  <div class="pctl__price-wrapper">
    <span :class="['pctl__price', { bold: comparePrice != discountPrice }]">{{ formatPrice(discountPrice) }}</span>
    <span v-if="comparePrice != discountPrice" class="pctl__compare-price">{{ formatPrice(comparePrice) }}</span>
  </div>
</template>

<script setup>
  /** ProductCardTypeC is used in PDP page on Complete the look section */
  import { toRefs, computed } from 'vue';
  import ImageField from '../../global/image.vue';
  import productCardProps from './product-card-props';

  const props = defineProps({
    product: productCardProps.product,
  });

  const { product } = toRefs(props);

  const discountPrice = computed(() => {
    const { price, compare_at_price } = product.value;
    const customerDiscountVal = window.customerDiscount(product.value.product.tags);

    if (compare_at_price > 0) {
      return Math.min(compare_at_price * (1 - customerDiscountVal), price);
    } else {
      return price * (1 - customerDiscountVal);
    }
  });

  const comparePrice = computed(() => {
    const { price, compare_at_price } = product.value;

    if (compare_at_price > 0) {
      return compare_at_price;
    } else {
      return price;
    }
  });

  const formatPrice = (price) => {
    return window.formattedPrice(price / 100);
  };

  const toggleQuickView = () => {
    window.toggleDrawer(true, 'QuickView', {
      product: product.value.product,
      selectedColor: product.value.selectedFirstOption,
    });
  };

  const handleKeyDownOnQuickView = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      toggleQuickView();
    }
  };
</script>
